import { CheckboxInterests } from '../checkbox-interests';

export class QuestionBase<T> {
  value: T;
  key: string;
  label: string;
  required: boolean;
  order: number;
  controlType: string;
  icon: string;
  dependsOn?: { key: string; value: string };
  isDisplayed: boolean;
  optionsCheckbox: Array<CheckboxInterests>;
  type: string;
  className: string;
  options: any;

  constructor(
    options: {
      value?: T;
      key?: string;
      label?: string;
      required?: boolean;
      order?: number;
      controlType?: string;
      icon?: string;
      dependsOn?: { key: string; value: string };
    } = {}
  ) {
    this.value = options.value;
    this.key = options.key || '';
    this.label = options.label || '';
    this.required = options.required;
    this.order = options.order === undefined ? 1 : options.order;
    this.controlType = options.controlType || '';
    this.icon = options.icon || '';
    this.dependsOn = options.dependsOn || undefined;
    this.setDisplaying({});
    this.optionsCheckbox = [];
  }

  setDisplaying(_dependsOn) {
    if (this.dependsOn && this.dependsOn.key !== _dependsOn.key) {
      return;
    }

    if (!this.dependsOn) {
      this.isDisplayed = true;
      return;
    }

    if (this.dependsOn.value === _dependsOn.value) {
      this.isDisplayed = true;
    } else {
      this.isDisplayed = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/models/question/question-base.ts